import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import robojacketsTheme from './theme/robojacketsTheme';
import SentryWrapper from './components/SentryWrapper';
import SignUpSelection from './components/SignUpSelection';
import CaregiverSignUpForm from './components/CaregiverSignUpForm';
import StudentSignUpForm from './components/StudentSignUpForm';
import PrivacyPolicy from './components/PrivacyPolicy';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import HouseholdProtectedRoute from './components/HouseholdProtectedRoute';
import Dashboard from './components/Dashboard';
import Navigation from './components/Navigation';
import HouseholdNavigation from './components/HouseholdNavigation';
import HouseholdDashboard from './components/HouseholdDashboard';
import Users from './components/Users';
import Groups from './components/Groups';
import Households from './components/Households';
import TeamSeeking from './components/TeamSeeking';
import Rosters from './components/Rosters';
import Analytics from './components/Analytics';
import Communications from './components/Communications';
import Scheduler from './components/Scheduler';
import Roles from './components/Roles';
import RoleApplications from './components/RoleApplications';
import GroupApplications from './components/GroupApplications';
import TeamSeekingTeams from './components/TeamSeekingTeams';
import Locations from './components/Admin/Locations';

function App() {
  return (
    <SentryWrapper>
      <ThemeProvider theme={robojacketsTheme}>
        <CssBaseline />
        <Router>
          <Routes>
            {/* Public routes - Registration */}
            <Route path="/" element={<SignUpSelection />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup/caregiver" element={<CaregiverSignUpForm />} />
            <Route path="/signup/student" element={<StudentSignUpForm />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            
            {/* Protected Household Routes */}
            <Route path="/household/*" element={
              <HouseholdProtectedRoute>
                {({ onLogout, authData }) => (
                  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                    <HouseholdNavigation onLogout={onLogout} authData={authData} />
                    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                      <Routes>
                        <Route path="/" element={<HouseholdDashboard authData={authData} />} />
                        <Route path="/dashboard" element={<HouseholdDashboard authData={authData} />} />
                        <Route path="/team-seeking" element={<TeamSeekingTeams authData={authData} />} />
                      </Routes>
                    </Box>
                  </Box>
                )}
              </HouseholdProtectedRoute>
            } />
            
            {/* Protected Crew Routes */}
            <Route path="/crew/*" element={
              <ProtectedRoute>
                {({ onLogout, currentUser }) => (
                  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                    <Navigation onLogout={onLogout} currentUser={currentUser} />
                    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/groups" element={<Groups currentUser={currentUser} />} />
                        <Route path="/households" element={<Households />} />
                        <Route path="/team-seeking" element={<TeamSeeking />} />
                        <Route path="/rosters" element={<Rosters />} />
                        <Route path="/analytics" element={<Analytics />} />
                        <Route path="/communications" element={<Communications />} />
                        <Route path="/scheduler" element={<Scheduler />} />
                        <Route path="/roles" element={<Roles />} />
                        <Route path="/role-applications" element={<RoleApplications currentUser={currentUser} />} />
                        <Route path="/team-applications" element={<GroupApplications currentUser={currentUser} />} />
                        <Route path="/admin/locations" element={<Locations />} />
                      </Routes>
                    </Box>
                  </Box>
                )}
              </ProtectedRoute>
            } />
            
            {/* Redirect old routes to crew */}
            <Route path="/dashboard" element={<Navigate to="/crew/dashboard" replace />} />
            <Route path="/users" element={<Navigate to="/crew/users" replace />} />
            <Route path="/groups" element={<Navigate to="/crew/groups" replace />} />
            <Route path="/households" element={<Navigate to="/crew/households" replace />} />
            <Route path="/team-seeking" element={<Navigate to="/crew/team-seeking" replace />} />
            <Route path="/rosters" element={<Navigate to="/crew/rosters" replace />} />
            <Route path="/analytics" element={<Navigate to="/crew/analytics" replace />} />
            <Route path="/communications" element={<Navigate to="/crew/communications" replace />} />
            <Route path="/scheduler" element={<Navigate to="/crew/scheduler" replace />} />
            <Route path="/roles" element={<Navigate to="/crew/roles" replace />} />
            <Route path="/role-applications" element={<Navigate to="/crew/role-applications" replace />} />
            <Route path="/team-applications" element={<Navigate to="/crew/team-applications" replace />} />
            <Route path="/admin/locations" element={<Navigate to="/crew/admin/locations" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </SentryWrapper>
  );
}

export default App;
